/**
 * How a finding's human-assigned SOURCE looks in the Findings table + triage dialog.
 * Mirrors the Digest-level provenance mapping (DigestTab) so the "is this ours or the
 * product's?" signal reads the same everywhere: product is benign, harness/infra loud.
 */
import type { FindingSource, FindingSubStatus } from '../../api/adminApi';

export const SOURCES: FindingSource[] = ['product', 'harness', 'agent-infra', 'unknown'];
export const SUBSTATUSES: FindingSubStatus[] = ['wont-fix', 'duplicate', 'not-reproducible', 'by-design', 'needs-info'];

export const SOURCE_LABEL: Record<FindingSource, string> = {
  product: 'product', harness: 'harness', 'agent-infra': 'agent infra', unknown: 'unknown',
};

export const SOURCE_VARIANT: Record<FindingSource, 'success' | 'warning' | 'error' | 'default'> = {
  product: 'success', harness: 'warning', 'agent-infra': 'error', unknown: 'default',
};
